import { render, staticRenderFns } from "./DepartmentSelect.vue?vue&type=template&id=c0a9dd7a&scoped=true"
import script from "./DepartmentSelect.vue?vue&type=script&lang=js"
export * from "./DepartmentSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a9dd7a",
  null
  
)

export default component.exports